export default "__VITE_ASSET__CQT653yW__"